export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <div className="inline-block bg-amber-100 text-amber-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Our Story
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
            Your Neighbors in Moving Excellence
          </h2>
          <p className="text-xl text-slate-600">
            For over 20 years, we've been the moving company Southern California families trust most.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-12 items-start mb-16">
          {/* Content - Left Side */}
          <div className="lg:col-span-3 space-y-6">
            <p className="text-lg text-slate-700 leading-relaxed">
              <strong className="text-slate-900">City to City Moving Company</strong> started with a simple belief: moving doesn't have to be stressful or expensive. Since our founding, we've helped thousands of families and businesses across Southern California relocate with confidence.
            </p>
            <p className="text-lg text-slate-700 leading-relaxed">
              We're a family-owned business based right here in Southern California. Our team knows these neighborhoods because we live here too. From Irvine to Indio, Newport Beach to Palm Springs, we understand the unique challenges of moving in our communities.
            </p>
            <p className="text-lg text-slate-700 leading-relaxed">
              Every member of our moving crew is professionally trained, background-checked, and committed to treating your belongings like their own. We don't just move boxes—we help families start new chapters.
            </p>

            {/* Local Trust Badges */}
            <div className="grid sm:grid-cols-3 gap-4 pt-6">
              <div className="bg-slate-50 rounded-xl p-5 border border-slate-200">
                <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-home-heart-line text-2xl text-amber-600"></i>
                </div>
                <div className="font-bold text-slate-900 mb-1">Family Owned</div>
                <div className="text-sm text-slate-600">Local business serving local families</div>
              </div>
              <div className="bg-slate-50 rounded-xl p-5 border border-slate-200">
                <div className="w-12 h-12 bg-sky-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-shield-check-line text-2xl text-sky-600"></i>
                </div>
                <div className="font-bold text-slate-900 mb-1">Fully Licensed</div>
                <div className="text-sm text-slate-600">Insured & bonded for your protection</div>
              </div>
              <div className="bg-slate-50 rounded-xl p-5 border border-slate-200">
                <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-3">
                  <i className="ri-customer-service-2-line text-2xl text-emerald-600"></i>
                </div>
                <div className="font-bold text-slate-900 mb-1">24/7 Support</div>
                <div className="text-sm text-slate-600">Always here when you need us</div>
              </div>
            </div>
          </div>

          {/* Image - Right Side */}
          <div className="lg:col-span-2">
            <div className="relative">
              <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/a5a96039de06d52adabbe17d81085bc5.jpg"
                  alt="City to City Moving Company professional team"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Floating Stats Card */}
              <div className="absolute -bottom-8 -left-8 bg-slate-900 text-white p-6 rounded-xl shadow-2xl">
                <div className="flex items-center gap-6">
                  <div>
                    <div className="text-4xl font-bold text-amber-400 mb-1">20+</div>
                    <div className="text-sm text-white/80">Years Serving</div>
                    <div className="text-sm text-white/80">SoCal</div>
                  </div>
                  <div className="w-px h-16 bg-white/20"></div>
                  <div>
                    <div className="text-4xl font-bold text-amber-400 mb-1">5K+</div>
                    <div className="text-sm text-white/80">Happy</div>
                    <div className="text-sm text-white/80">Customers</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Banner */}
        <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 rounded-2xl p-8 sm:p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Ready to Experience the Difference?
          </h3>
          <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto">
            Join thousands of satisfied customers who chose the moving company their neighbors recommend.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:7606257767" 
              className="inline-flex items-center justify-center bg-amber-500 text-slate-900 px-8 py-4 rounded-lg font-bold hover:bg-amber-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call (760) 625-7767
            </a>
            <a 
              href="#quote-form" 
              className="inline-flex items-center justify-center bg-white text-slate-900 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-file-text-line mr-2"></i>
              Get Free Quote
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}